<template>
  <div :class="{'op--modal-container':true, 'hide':!show}" @click="close">
    <div class="op--modal">
      <div class="op--modal-content promo-form" @click.stop>
        <div class="heading" id="addPromo">Add Promo</div>

        <div class="error-box" v-show="!!errorReturn">{{ errorReturn }}</div>

        <div class="row row-padding">
          <div class="data-field">
            <div class="label">Name</div>
            <input type="text" :class="{'input':true, 'has-error':!!errorMsg.promoName}"
              v-model="promoName" :disabled="loading" />
            <span class="error-msg">{{ errorMsg.promoName }}</span>
          </div>
        </div>

        <div class="row row-padding">
          <div class="data-field">
            <div class="label">Description</div>
            <textarea v-model="description" class="input" :disabled="loading"></textarea>
          </div>
        </div>

        <div class="row row-padding">
          <div class="column small-12 end">
            <div class="data-field input-date">
              <div class="label">Start Date</div>
              <div class="row">
                <div class="column small-5 padding-R">
                  <datepicker :format="calendarFormat" class="datepicker inline"
                    v-model="startDate" :disabled-picker="loading" :disabled="startDateDisabled"
                    :input-class="{'datepicker-empty':errorMsg.startDate}"
                  ></datepicker>
                  <span class="error-msg">{{ errorMsg.startDate || errorMsg.startDateHour || errorMsg.startDateMinute }}</span>
                </div>
                <div class="column small-3 padding-L">
                  <select v-model="startDateHour" :disabled="loading"
                    :class="{'has-error':!!errorMsg.startDateHour}">
                    <option value="" disabled selected>Hour</option>
                    <option v-for="x in 24" :value="leadingZero(x - 1)">{{ leadingZero(x - 1) }}</option>
                  </select>
                </div>
                <div class="column small-1 text-center"><span class="time">:</span></div>
                <div class="column small-3 padding-R">
                  <select v-model="startDateMinute" :disabled="loading"
                    :class="{'has-error':!!errorMsg.startDateMinute}">
                    <option value="" disabled selected>Minute</option>
                    <option v-for="x in 12" :value="leadingZero((x - 1) * 5)">{{ leadingZero((x - 1) * 5) }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row row-padding">
          <div class="column small-12 end">
            <div class="data-field input-date">
              <div class="label">Expiration Date</div>
              <div class="row">
                <div class="column small-5 padding-R">
                  <datepicker :format="calendarFormat" class="datepicker inline"
                  v-model="expirationDate" :disabled-picker="loading" :disabled="expirationDateDisabled"
                  :input-class="{'datepicker-empty':errorMsg.expirationDate}"
                  ></datepicker>
                  <span class="error-msg">{{ errorMsg.expirationDate || errorMsg.expirationDateHour || errorMsg.expirationDateMinute }}</span>
                </div>
                <div class="column small-3 padding-L">
                  <select v-model="expirationDateHour" :disabled="loading"
                    :class="{'has-error':!!errorMsg.expirationDateHour}">
                    <option value="" disabled selected>Hour</option>
                    <option v-for="x in 24" :value="leadingZero(x - 1)">{{ leadingZero(x - 1) }}</option>
                  </select>
                </div>
                <div class="column small-1 text-center"><span class="time">:</span></div>
                <div class="column small-3 padding-R">
                  <select v-model="expirationDateMinute" :disabled="loading"
                    :class="{'has-error':!!errorMsg.expirationDateMinute}">
                    <option value="" disabled selected>Minute</option>
                    <option v-for="x in 12" :value="leadingZero((x - 1) * 5)">{{ leadingZero((x - 1) * 5) }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row row-padding">
          <div class="column small-6 padding-R">
            <div class="data-field">
              <div class="label">Days Valid after Redemption</div>
              <input type="text" :disabled="loading" v-model="validDays"
               :class="{'input':true, 'has-error':!!errorMsg.validDays}" />
              <span class="error-msg">{{ errorMsg.validDays }}</span>
            </div>
          </div>
          <div class="column small-6 padding-L" v-show="!isMobile">
            <div class="data-field">
              <div class="label">Valid Only for New Users</div>
              <select v-model="validNewUser" :disabled="loading">
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row row-padding">
          <div class="column small-4 padding-R promo-code">
            <div class="data-field">
              <div class="label">Promo Code</div>
              <input type="text" :disabled="loading" v-model="code" @keydown.space="(event) => event.preventDefault()"
                :class="{'input':true, 'has-error':!!errorMsg.code}" />
              <span class="error-msg">{{ errorMsg.code }}</span>
            </div>
          </div>
          <div class="column small-4 padding-R padding-L credit-amount">
            <div class="data-field">
              <div class="label">Credit Amount</div>
              <input type="text" :disabled="loading" v-model="amount"
                :class="{'input':true, 'has-error':!!errorMsg.amount}" />
              <span class="error-msg">{{ errorMsg.amount }}</span>
            </div>
          </div>
          <div class="column small-6 padding-L w-50 padding-r" v-show="isMobile">
            <div class="data-field">
              <div class="label">Valid Only for New Users</div>
              <select v-model="validNewUser" :disabled="loading">
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>
          <div class="column small-4 padding-L w-50">
            <div class="data-field">
              <div class="label">Number of Codes to Redeem</div>
              <input type="text" :disabled="loading" v-model="totalCodes"
                :class="{'input':true, 'has-error':!!errorMsg.totalCodes}" />
              <span class="error-msg">{{ errorMsg.totalCodes }}</span>
            </div>
          </div>
        </div>

        <div class="row row-button">
          <div class="column small-12">
            <div class="button cta error small" @click="close">Cancel</div>
            <div class="button cta success small" @click="save">Save</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import datepicker from 'vuejs-datepicker'
import ApiPromo from '@/modules/api/promo'

export default {
  name: 'promo-add',
  components: { datepicker },
  props: [ 'isMobile' ],
  data () {
    return {
      promoName: '',
      description: '',
      startDate: '',
      startDateHour: '',
      startDateMinute: '',
      expirationDate: '',
      expirationDateHour: '',
      expirationDateMinute: '',
      validDays: '',
      validNewUser: '1',
      code: '',
      amount: '',
      totalCodes: '',
      errorMsg: {
        promoName: '',
        startDate: '',
        startDateHour: '',
        startDateMinute: '',
        expirationDate: '',
        expirationDateHour: '',
        expirationDateMinute: '',
        validDays: '',
        code: '',
        amount: '',
        totalCodes: ''
      },
      errorReturn: '',
      today: moment().subtract(1, 'days'),
      loading: false
    }
  },
  computed: {
    show () { return this.$store.state.promo.showAdd },
    startDateDisabled () {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(
            this.today.subtract(1, 'months').format('YYYY'),
            this.today.format('MM'),
            this.today.format('DD')
          )
        }
      }
      
      return {
        to: new Date(
          this.today.format('YYYY'),
          this.today.subtract(1, 'months').format('MM'),
          this.today.format('DD')
        )
      }
    },
    expirationDateDisabled () {
      let date = this.startDate ? moment(this.startDate).add(1, 'days') : moment()
      if (date.format('MM') === '01') {
        return {
          to: new Date(
            date.subtract(1, 'months').format('YYYY'),
            date.format('MM'),
            date.format('DD')
          )
        }
      }

      return {
        to: new Date(
          date.format('YYYY'),
          date.subtract(1, 'months').format('MM'),
          date.format('DD')
        )
      }
    }
  },
  methods: {
    close () {
      this.$store.commit('promo/setShowAdd', false)
    },
    calendarFormat (date) { return moment(date).format('MM/DD/YYYY') },
    save () {
      let self = this
      self.$emit('save')
      if (self.loading) { return }

      if (self.validate()) {
        self.loading = true
        let startDate = moment(self.startDate)
        startDate = moment(startDate.format('MM/DD/YYYY ') + self.startDateHour + ':' + self.startDateMinute)
        let expirationDate = moment(self.expirationDate)
        expirationDate = moment(expirationDate.format('MM/DD/YYYY ') + self.startDateHour + ':' + self.startDateMinute)

        ApiPromo.addPromoDetails(self, {
          name: self.promoName,
          description: self.description,
          startDate: startDate.format('YYYY-MM-DD HH:mm:ss'),
          expirationDate: expirationDate.format('YYYY-MM-DD HH:mm:ss'),
          validDays: self.validDays,
          validOnlyForNewUser: self.validNewUser,
          promoCode: self.code,
          amount: self.amount,
          totalCodes: self.totalCodes,
          batchTypeId: 1
        }, function (res) {
          self.loading = false
          if (res.error) {
            self.errorReturn = res.error.message
            self.scrollToTop()
            return
          }

          self.$emit('save')
          self.close()
          self.clearForm()
        })
      }
    },
    validate () {
      this.resetErrorMsg()
      let hasError = false

      for (let field in this.errorMsg) {
        if (this[field] === '') {
          this.errorMsg[field] = 'This field cannot be empty.'
          hasError = true
        }
      }

      return !hasError
    },
    resetErrorMsg () {
      this.errorMsg = {
        promoName: '',
        startDate: '',
        startDateHour: '',
        startDateMinute: '',
        expirationDate: '',
        expirationDateHour: '',
        expirationDateMinute: '',
        validDays: '',
        code: '',
        amount: '',
        totalCodes: ''
      }
    },
    clearForm () {
      this.promoName = ''
      this.description = ''
      this.startDate = ''
      this.startDateHour = ''
      this.startDateMinute = ''
      this.expirationDate = ''
      this.expirationDateHour = ''
      this.expirationDateMinute = ''
      this.validDays = ''
      this.validNewUser = '1'
      this.code = ''
      this.amount = ''
      this.totalCodes = ''
    },
    scrollToTop () {
      let elmnt = document.getElementById('addPromo')
      elmnt.scrollIntoView({behavior: 'smooth', block: 'start'})
    },
    leadingZero (x) { return x < 10 ? '0' + x : x }
  },
  watch: {
    show: function (value) {

    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.op--modal {
  display: table;
  width: 100%;
  height: 100%;
}
.op--modal-content.center{
  display: table-cell;
  vertical-align: middle;
}

.promo-form{
  background-color: #fff;
  width: 600px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  position: relative;
}

.heading{
  background: #333;
  color: #fff;
  font-weight: 600;
  font-size: 21px;
  padding: 10px 20px;
  margin-bottom: 20px;
}
.clear{ clear:both; }

.data-field{
  position: relative;
  margin-bottom: 10px;
  .label{
    color: #888;
    font-weight: 600;
    font-size: 12px;
    line-height: 130%;
    margin-bottom: 1px;

    &.has-error{ color: #f20d0d; }
    &.underline{
      padding-bottom: 3px;
      margin-bottom: 10px;
      border-bottom: 1px solid #ccc;
    }
    .secondary{
      color: #5390dc;
      display: inline-block;
      margin-left:3px;
    }
  }
  .input{
    margin: 1px 0 0;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background: #eee; }
  }
  textarea{
    border: 1px solid #ddd;
    width: 100%;
    height: 150px;
    resize: none;
    padding: 10px;
    font-size: 13px;
    color: #555;
    outline: none;
    margin-top: 5px;

    &.has-error{ border-color: #f20d0d; }
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
}
select{
  margin-top: 1px;
  border: 1px solid #ddd;
  padding: 10px;
  color: #333;
  height: 45px;
  position: relative;
  font-size:14px;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('/assets/img/dropdown-arrow.png');
  background-repeat: no-repeat;
  background-position: right 50%;
  transition: all .35s ease;

  &.has-error{ border-color: #f20d0d; }
  &:disabled{ background-color: #eee; }
}
.time{
  display: inline-block;
  line-height: 45px;
}
.row-button{
  background: #f6f6f6;
  border-top:1px solid #ddd;
  text-align: center;
  padding: 10px 0;

  .button{
    margin: 0 5px;
    min-width: 150px;
  }
}

.row{ max-width: 100%; }
.row-padding{ padding: 5px 15px; }
.padding-L{ padding-left: 10px; }
.padding-R{ padding-right: 10px; }
.margin-B{ margin-bottom: 20px; }
.text-center{ text-align: center; }

.error-box{
  margin:0 30px;
  border:1px solid #f34c31;
  color:#f34c31;
  padding: 5px;
  margin-bottom: 15px;
  font-size:14px;
  font-weight:600;
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .padding-L, .padding-R {
    padding: 0;
  }

  .small-5, .small-4, .small-6, .promo-form {
    width: 100%;
  }
  .small-3 {
    width: 45%;
  }
  .small-1 {
    width: 10%;
  }
  .small-5 {
    margin-bottom: 10px;
  }

  .data-field textarea {
    height: 80px;
  }
  .input-date {
    .small-5 {
      width: 45%;
      padding-right: 5%;
    }
    .small-3 {
      width: 25%;
      padding: 0;
      margin: 0;
      float: left;
    }
    .small-1 {
      width: 5%;
    }
  }
  .promo-code {
    width: 50%;
    padding-right: 5%;
  }
  .credit-amount {
    width: 50%;
  }
  .w-50 {
    width: 50%;
    &.padding-r {
      padding-right: 5%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Promo/PromoAdd.vue